import { inject, Injectable, signal } from '@angular/core';
import { ProjectsDataService } from '@app/shared/services/projects-data.service';
import { CooperationProject } from '@app/shared/types/models/cooperation/cooperation-project.model';
import { CooperationProjectDTO } from '../dtos/cooperation/cooperation-project.dto';
import { AbstractFactory } from './abstract.factory';

@Injectable({ providedIn: 'root' })
export class CooperationProjectFactory extends AbstractFactory<CooperationProjectDTO, CooperationProject> {
  private readonly projectsDataService = inject(ProjectsDataService);

  public produce(item: CooperationProjectDTO): CooperationProject {
    if (item.project) {
      this.projectsDataService.upsertLocalData(item.project);
    }
    return new CooperationProject({
      id: item.id,
      cooperationId: item.cooperationId,
      project: item.project ? this.projectsDataService.getById(item.project.id) : signal(undefined)
    });
  }
}
